import React from 'react';
import {Link} from 'react-router-dom';

// HeaderUserControls stateless component
const HeaderUserControls = () =>
	<div className="navbar-end">
		<Link to={`/`} className="navbar-item">
			Home
		</Link>

		<div className="navbar-item has-dropdown is-hoverable">
			<div className="navbar-link">
				Quienes Somos
			</div>
			<div className="navbar-dropdown">
				<Link to={`/about/foundation`} className="navbar-item">
					<div>
						La Fundación
					</div>
				</Link>
				<Link to={`/about/history`} className="navbar-item">
					<div>
						Historia
					</div>
				</Link>
				<Link to={`/about/style`} className="navbar-item">
					<div>
						Filosofía
					</div>
				</Link>
				<Link to={`/about/belts`} className="navbar-item">
					<div>
						Grados
					</div>
				</Link>
			</div>
		</div>

		<Link to={`/contact`} className="navbar-item">
			Contacto
		</Link>

		<Link to={`/login`} className="navbar-item">
			Login
		</Link>

		<div className="navbar-item has-dropdown is-hoverable is-hidden">
			<div className="navbar-link">
				Estilo
			</div>
			<div className="navbar-dropdown">
				<Link to={`/`} className="navbar-item">
					<div>
						<span className="icon is-small">
							<i className="fa fa-user-circle-o"></i>
						</span>
						Profile
					</div>
				</Link>
				<Link to={`/`} className="navbar-item">
					<div>
						<span className="icon is-small">
							<i className="fa fa-bug"></i>
						</span>
						Report bug
					</div>
				</Link>
				<Link to={`/`} className="navbar-item">
					<div>
						<span className="icon is-small">
							<i className="fa fa-sign-out"></i>
						</span>
						Sign Out
					</div>
				</Link>
			</div>
		</div>
	</div>

export default HeaderUserControls;




// WEBPACK FOOTER //
// ./src/components/Header/HeaderUserControls.js